export default (theme) => ({
  pageSection: {
    padding: 10,
    //paddingTop: 75,
    paddingLeft: 25,
  },
  AdvancePanel: {
    padding: "0px 25px",
    borderTop: "1px solid #e0e0e0",
    marginTop: 15,
    marginBottom: 15,
  },
  inputLabel: {
    //color: "rgba(0, 0, 0)",
    paddingBottom: 10,
    //fontWeight: 600,
    fontSize: 13,
  },
});
